export default "__VITE_ASSET__Bn0JU5Lm__"